export default {
  bovespa: 'Bovespa Stock',
  volume: 'Volume',
  price: 'Price',
  mentions: 'Mentions',
};
